import queryString from 'query-string';

export default function addQueryStringToUrl(url, newQuery) {
    if (url === null) {
        return null;
    }
    const queryStringIndex = url.indexOf('?');
    const query =
        queryStringIndex !== -1 ? queryString.parse(url.substr(queryStringIndex) + 1) : {};
    return `${
        queryStringIndex !== -1 ? url.substr(0, url.indexOf('?')) : url
    }?${queryString.stringify({
        ...query,
        ...newQuery,
    })}`;
}
